import { render } from "./EventDashboard.vue?vue&type=template&id=2fb855ca&scoped=true"
import script from "./EventDashboard.vue?vue&type=script&lang=js"
export * from "./EventDashboard.vue?vue&type=script&lang=js"

import "./EventDashboard.vue?vue&type=style&index=0&id=2fb855ca&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb855ca"]])

export default __exports__